export const autoFocusInput = (input: HTMLInputElement) => {
    if (input !== null) {
        input.focus();
    }
};
